export enum DownloadExpiryKeys {
  OneMinute,
  FiveMinutes,
  OneHour,
  FiveHours,
  OneDay,
  TwoDays,
  FiveDays,
  SevenDays
}
